import { Div, Image } from '@kizi/core-components';
import React from 'react';

export const BlackFridayDeal = ({ customAttributes }) => {
  const isBlackFridayDeal =
    customAttributes?.find((el) => el?.description === 'Black Friday')?.value ||
    'false';

  if (isBlackFridayDeal !== 'true') {
    return null;
  }

  return (
    <Div position="absolute" right={0} top={'-15px'} zIndex={10}>
      <Image
        alt={`black-friday-banner`}
        src={
          "https://comparators.kizi.nl/assets/logo's/Banner%20-_%20Bottom.png"
        }
        style={{ marginTop: 0 }}
      />
    </Div>
  );
};
